import { render } from "./DashboardMobile.vue?vue&type=template&id=2ad9b5b6&scoped=true"
import script from "./DashboardMobile.vue?vue&type=script&lang=js"
export * from "./DashboardMobile.vue?vue&type=script&lang=js"

import "./DashboardMobile.vue?vue&type=style&index=0&id=2ad9b5b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad9b5b6"]])

export default __exports__